import { useEffect, useState } from 'react';
import * as UAParser from 'ua-parser-js';

interface ScreenInfo {
  width: number | null;
  height: number | null;
  pixelRatio: number | null;
}

interface BrowserInfo {
  name: string | null;
  version: string | null;
}

interface OSInfo {
  name: string | null;
  version: string | null;
}

interface DeviceDetails {
  model: string | null;
  type: string | null;
  vendor: string | null;
}

interface DeviceInfo {
  appName: string | null;
  appVersion: string | null;
  userAgent: string | null;
  platform: string | null;
  language: string | null;
  deviceMemory: number | null;
  cpuCores: number | null;
  screen: ScreenInfo;
  touchSupport: boolean;
  online: boolean | null;
  browser: BrowserInfo;
  os: OSInfo;
  device: DeviceDetails;
}

const useDeviceInfo = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    appName: null,
    appVersion: null,
    userAgent: null,
    platform: null,
    language: null,
    deviceMemory: null,
    cpuCores: null,
    screen: {
      width: null,
      height: null,
      pixelRatio: null,
    },
    touchSupport: false,
    online: null,
    browser: {
      name: null,
      version: null,
    },
    os: {
      name: null,
      version: null,
    },
    device: {
      model: null,
      type: null,
      vendor: null,
    },
  });

  useEffect(() => {
    const parser = new UAParser.UAParser(); 
    const parsedResult = parser.getResult();

    const info: DeviceInfo = {
      appName: navigator.appName || null,
      appVersion: navigator.appVersion || null,
      userAgent: navigator.userAgent || null,
      platform: navigator.platform || null,
      language: navigator.language || null,
      deviceMemory: (navigator as any).deviceMemory || null,
      cpuCores: navigator.hardwareConcurrency || null,
      screen: {
        width: window.screen.width || null,
        height: window.screen.height || null,
        pixelRatio: window.devicePixelRatio || null,
      },
      touchSupport: 'ontouchstart' in window,
      online: navigator.onLine,
      browser: {
        name: parsedResult.browser.name || null,
        version: parsedResult.browser.version || null,
      },
      os: {
        name: parsedResult.os.name || null,
        version: parsedResult.os.version || null,
      },
      device: {
        model: parsedResult.device.model || null,
        type: parsedResult.device.type || null,
        vendor: parsedResult.device.vendor || null,
      },
    };

    setDeviceInfo(info);
  }, []);

  return deviceInfo;
};

export default useDeviceInfo;
